import { Close } from '@radix-ui/react-dialog';

import styles from './modal-components.module.css';

export const ModalClose = () => (
  <Close asChild>
    <button className={styles.closeButton} aria-label="Close">
      <svg width="18" height="18" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.4375 5.16403L14.4335 4.15625L4.25951 14.3686L5.26351 15.3764L15.4375 5.16403Z"
          fill="currentColor"
        />
        <path
          d="M5.16025 4.21739L4.15625 5.22517L14.3302 15.4375L15.3342 14.4297L5.16025 4.21739Z"
          fill="currentColor"
        />
      </svg>
    </button>
  </Close>
);
